import {
  // FaReact,
  FaGithub,
  FaLinkedin,
  FaEnvelope,
  FaHome,
  FaBrain,
  FaInfoCircle,
  FaGamepad,
  FaFigma,
  FaServer,
} from "react-icons/fa";

import logo_w from "../assets/imgs/logo_w.png";
import logo from "../assets/imgs/logo.png";
import {
  BsCodeSlash,
  // BsBraces
} from "react-icons/bs";
// import icon_w from '../assets/imgs/icon_w.svg';
// import icon from "../assets/imgs/icon.svg";

const navbarLinkIconSize = 20;

export const dateOfBirth = '1989-04-08';

export const navbarLinks = [
  {
    id: "home",
    name: "Home",
    route: "/",
    icon: <FaHome size={navbarLinkIconSize} />,
  },
  {
    id: "about",
    name: "About me",
    route: "/about",
    icon: <FaInfoCircle size={navbarLinkIconSize} />,
  },
  {
    id: "expertise",
    name: "Expertise",
    route: "/expertise",
    icon: <FaBrain size={navbarLinkIconSize} />,
  },
  {
    id: "contact",
    name: "Contact",
    route: "/contact",
    icon: <FaEnvelope size={navbarLinkIconSize} />,
  },
];

const projectIconSize = 100;
export const skillLanguages = [
  {
    id: "design",
    language: "Design",
    route: "/expertise",
    icon: <FaFigma size={projectIconSize} />,
    // color: "rgba(255, 213, 0, 1)",
    color:
      // "bg-violet-300 dark:bg-violet-500 hover:bg-violet-200 dark:hover:bg-violet-600 hover:duration-300",
      "bg-violet-500 dark:bg-violet-300 hover:bg-violet-600 dark:hover:bg-violet-200 hover:duration-300",
  },
  {
    id: "webdev",
    language: "Web Development",
    route: "/expertise",
    icon: <BsCodeSlash size={projectIconSize} />,
    // color: "rgba(245, 132, 47, 1)",
    color:
      "bg-orange-300 dark:bg-orange-600 hover:bg-orange-200 dark:hover:bg-orange-700 hover:duration-300",
  },
  {
    id: "gamedev",
    language: "Game Dev",
    route: "/expertise",
    icon: <FaGamepad size={projectIconSize} />,
    // color: "rgba(0, 201, 24, 1)",
    color:
      "bg-green-300 dark:bg-green-600 hover:bg-green-200 dark:hover:bg-green-700 hover:duration-300",
  },
  {
    id: "apis",
    language: "Apis",
    route: "/expertise",
    icon: <FaServer size={projectIconSize} strokeWidth={1} />,
    // color: "rgba(74, 83, 255, 1)",
    color:
      "bg-blue-300 dark:bg-blue-600 hover:bg-blue-200 dark:hover:bg-blue-700 hover:duration-300",
  },
];

export const skill = [
  {
    group_id: "reactjs",
    name: "React JS",
    color:
      "bg-blue-300 dark:bg-blue-700 hover:bg-blue-200 dark:hover:bg-blue-800 hover:duration-300",
    data: [
      {
        id: "demos",
        name: "Demos",
        route: "demos",
      },
      {
        id: "components",
        name: "Components",
        route: "components",
      },
      {
        id: "hooks",
        name: "Hooks",
        route: "hooks",
      },
      {
        id: "customhooks",
        name: "Custom Hooks",
        route: "custom-hooks",
      },
    ],
  },
  {
    group_id: "vanillajs",
    name: "Vanilla Javascript",
    color:
      "bg-yellow-300 dark:bg-yellow-500 hover:bg-yellow-200 dark:hover:bg-yellow-600 hover:duration-300",
    data: [
      {
        id: "demos",
        name: "Demos",
        route: "demos",
      },
      {
        id: "variables",
        name: "Variables",
        route: "variables",
      },
      {
        id: "functions",
        name: "Functions",
        route: "functions",
      },
      {
        id: "arrays",
        name: "Arrays",
        route: "arrays",
      },
      {
        id: "objects",
        name: "Objects",
        route: "objects",
      },
      {
        id: "loops",
        name: "Loops",
        route: "loops",
      },
      {
        id: "events",
        name: "Events",
        route: "events",
      },
    ],
  },
  {
    group_id: "html",
    name: "HTML + CSS",
    color:
      "bg-orange-300 dark:bg-orange-700 hover:bg-orange-200 dark:hover:bg-orange-800 hover:duration-300",
    data: [
      {
        id: "demos",
        name: "Demos",
        route: "demos",
      },
      {
        id: "structure",
        name: "Structure",
        route: "structure",
      },
      {
        id: "lists",
        name: "Lists",
        route: "lists",
      },
      {
        id: "tables",
        name: "Tables",
        route: "tables",
      },
      {
        id: "forms",
        name: "Forms",
        route: "forms",
      },
    ],
  },
  {
    group_id: "nodejs",
    name: "Node JS",
    color:
      "bg-green-300 dark:bg-green-700 hover:bg-green-200 dark:hover:bg-green-800 hover:duration-300",
    data: [
      // {
      //   id: "demos",
      //   name: "Demos",
      //   route: "demos",
      // },
      {
        id: "express",
        name: "Express",
        route: "express",
      },
      {
        id: "cors",
        name: "Cors",
        route: "cors",
      },
      {
        id: "swagger",
        name: "Swagger",
        route: "swagger",
      },
      {
        id: "socket-io",
        name: "Socket io",
        route: "socket-io",
      },
    ],
  },
];

const contactIconSize = 72;
export const contactData = [
  {
    id: "github",
    description:
      "Please feel free to check the Github repositories I have been working during these years.",
    url: "http://www.github.com/JOMADELEMA",
    name: "/JOMADELEMA",
    icon: <FaGithub size={contactIconSize} />,
  },
  {
    id: "linkedin",
    description:
      "Also check my linkedin profile to know about my professional career and some of my certifications.",
    url: "http://www.linkedin.com/in/JOMADELEMA",
    name: "/JOMADELEMA",
    icon: <FaLinkedin size={contactIconSize} />,
  },
  {
    id: "email",
    description: "e-mail me to get in touch.",
    url: "mailto:me@jomadelema.com",
    name: "me@jomadelema.com",
    icon: <FaEnvelope size={contactIconSize} />,
  },
];

export const quotes = [
  {
    quote:
      "Live as if you were to die tomorrow. Learn as if you were to live forever.",
    author: "Mahatma Gandhi",
  },
  {
    quote: "Wisdom... comes not from age, but from education and learning.",
    author: "Anton Chekhov",
  },
  {
    quote:
      "Commit yourself to lifelong learning. The most valuable asset you'll ever have is your mind and what you put into it.",
    author: "Albert Einstein",
  },
  {
    quote:
      "You don't learn to walk by following rules. You learn by doing, and by falling over.",
    author: "Albert Einstein",
  },
  {
    quote:
      "Success is no accident. It is hard work, perseverance, learning, studying, sacrifice and most of all, love of what you are doing or learning to do.",
    author: "Pele",
  },
  {
    quote:
      "Continuous learning is the minimum requirement for success in any field.",
    author: "Brian Tracy",
  },
  {
    quote:
      "Life is like riding a bicycle. To keep your balance you must keep moving.",
    author: "Albert Einstein",
  },
  {
    quote: "Don't just count your years, make your years count.",
    author: "George Mereith",
  },
  {
    quote:
      "Knowledge, like air, is vital to life. Like air, no one should be denied it.",
    author: "Alan Moore",
  },
  {
    quote: "Learning is not a destination, it is a continuous process.",
    author: "Kevin Horsley",
  },
];

export const aboutMeData = {
  id: "JOMADELEMA",
  name: "Jorge de León M.",
  logo_w,
  logo,
  // icon_w,
  // icon,
  currentLevel: 36,
  description:
    "I am a curious and passionate learner who loves to explore new ideas and technologies. I am always eager to expand my knowledge and skills in programming and beyond.",
  interests: [
    "Web Development",
    "Front End",
    "UI/UX Designs",
    "Backend",
    "Databases",
  ],
  hobbies: ["Photography", "Cooking", "Drawing", "and of course Video games"],
  languages: ["Spanish", "English"],
};

export const htmlDemos = [
  {
    id: "photographer",
    name: "Photographer Layout",
    description: "Responsive site idea for a Photographer site layout.",
    route: "photographer",
  },
  {
    id: "imageGrid",
    name: "Image Grid",
    description:
      "Responsive site idea of an image grid for hand and digital drawings ",
    route: "image-grid",
  },
  {
    id: "landingPage",
    name: "Landing Page",
    description: "Responsive landing page concept for a { ???? } ",
    route: "landing-page",
  },
  {
    id: "blog",
    name: "Blog",
    description: "Responsive blog design",
    route: "blog",
  },
];

export const designs = [
  {
    title: "404 not found message",
    description: "Website 404 Not found error message site",
    url: "/imgs/designs/404-not-found.jpg",
    social: "https://x.com/jomadelema_dev/status/1653466035750567936",
    tags: "Figma",
    type: "web",
  },
  {
    title: "e-commerce Shop",
    description: "Single item page for an e-commerce website",
    url: "/imgs/designs/ecommerce-shop-single-item.jpg",
    social: "https://x.com/jomadelema_dev/status/1650734634529955840",
    tags: "Figma",
    type: "web",
  },
  {
    title: "Calculator",
    description: "Calculator app with neumorphism effect",
    url: "/imgs/designs/calculator.jpg",
    social: "https://x.com/jomadelema_dev/status/1655629418306449430",
    tags: "Figma, e-commerce",
    type: "mobile",
  },
  {
    title: "Countdown Timer",
    description: "Countdown timer for a webapp",
    url: "/imgs/designs/countdown-timer.jpg",
    social: "https://x.com/jomadelema_dev/status/1656304593150541825",
    tags: "lroem loem lorem poem",
    type: "web",
  },
  {
    title: "Location Tracker",
    description: "A tracker for web site using neubrutalism design",
    url: "/imgs/designs/location-tracker.jpg",
    social: "https://x.com/jomadelema_dev/status/1659206902574882818",
    tags: "tracker, location, neubrutalism",
    type: "web",
  },
  {
    title: "Home Monitoring Dashboard",
    description:
      "A dashboard usign glassmorphism design for a home monitoring dashboard",
    url: "/imgs/designs/home-monitoring.jpg",
    social: "https://x.com/jomadelema_dev/status/1659703209357717505",
    tags: "monitoring, glassmorphism",
    type: "web",
  },
  {
    title: "Card Checkout",
    description: "Mobile device credit card checkout and success message",
    url: "/imgs/designs/card-checkout.jpg",
    social: "https://x.com/jomadelema_dev/status/1650734634529955840",
    tags: "Figma",
    type: "mobile",
  },
  {
    title: "Error and Success Message",
    description: "Success and Error message for a mobile device app",
    url: "/imgs/designs/error-success-message.jpg",
    social: "https://x.com/jomadelema_dev/status/1654628087324082176",
    tags: "error, success, figma",
    type: "mobile",
  },
  {
    title: "Leaderboard",
    description: "Season leaderboard design for a mobile game or app",
    url: "/imgs/designs/leaderboard.jpg",
    social: "https://x.com/IftahazK/status/1659472252310814720",
    tags: "leaderboard",
    type: "mobile",
  },
  {
    title: "Onboarding",
    description: "Cards to motivate the user to sign up",
    url: "/imgs/designs/onboarding.jpg",
    social: "https://x.com/jomadelema_dev/status/1661235134782402562",
    tags: "sign up",
    type: "mobile",
  },
  {
    title: "Subscribe",
    description: "Screen design to motivate the user to subscribe to updates",
    url: "/imgs/designs/subscribe.jpg",
    social: "https://x.com/jomadelema_dev/status/1662124300919271424",
    tags: "subscribe",
    type: "web",
  },
  {
    title: "Pricing",
    description: "Design to show the user the available plans",
    url: "/imgs/designs/pricing.jpg",
    social: "https://x.com/jomadelema_dev/status/1664280454336512002",
    tags: "pricing",
    type: "web",
  },
  {
    title: "File Upload",
    description: "Design to show the user the available plans",
    url: "/imgs/designs/file-uploading.jpg",
    social: "https://x.com/jomadelema_dev/status/1664782574743330817",
    tags: "file, upload",
    type: "mobile",
  },
  {
    title: "Calendar",
    description: "A themed by month calendar idea",
    url: "/imgs/designs/calendar.jpg",
    social: "https://x.com/jomadelema_dev/status/1669193591325851649",
    tags: "calendar",
    type: "mobile",
  },
  {
    title: "Testimonials",
    description: "An elegant way to show the customers testimonials",
    url: "/imgs/designs/testimonials.jpg",
    social: "https://x.com/jomadelema_dev/status/1669542990136655874",
    tags: "testimonial",
    type: "web",
  },
  {
    title: "Info Card",
    description: "A glassmorphism style card to show information",
    url: "/imgs/designs/info-card.jpg",
    social: "https://x.com/jomadelema_dev/status/1672443370059317248",
    tags: "testimonial",
    type: "web",
  },
];
